import type { IGoogleRating, IGoogleRatingModel } from '../types/googleRating'
export const GoogleRatingFromJSON = (json: IGoogleRating): IGoogleRatingModel => {
	const fromJSON = (json: IGoogleRating) => {
		const { ratings_count, ...rest } = json

		return {
			...rest,
			ratingsCount: ratings_count,
		}
	}

	return { ...fromJSON(json) }
}

export const GoogleRatingToJSON = (obj: Partial<IGoogleRatingModel>): Partial<IGoogleRating> => {
	const { ratingsCount, ...rest } = obj

	return {
		...rest,
		ratings_count: ratingsCount,
	}
}
